import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_GM_CURRENCY, GET_GM_CURRENCY_SUCCESS, GET_GM_CURRENCY_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getGmCurrency({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/gm-dashboard-filters/currency`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_GM_CURRENCY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GM_CURRENCY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GM_CURRENCY_ERROR, payload: error });
  }
}

export function* watchGetGmCurrency() {
  yield takeEvery(GET_GM_CURRENCY, getGmCurrency);
}

function* getGmCurrencySaga() {
  yield all([fork(watchGetGmCurrency)]);
}

export default getGmCurrencySaga;